"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var customRadioGroupStyles = makeStyles_1.default(function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return ({
        container: {},
        disclaimer: {
            fontSize: typography.fontSM,
            '& span': {
                fontWeight: 'bold',
            },
            '& a': {
                fontWeight: 'bold',
            },
        },
        root: {
            '&:hover': {
                backgroundColor: 'transparent',
            },
            '& svg': {
                fontSize: '20px',
            },
            width: '40px',
            height: '40px',
        },
        radioButtonContainer: {
            display: 'flex',
            alignItems: 'center',
        },
        radioButtonGroup: {
            display: 'flex',
            flexDirection: 'row',
        },
        errorMessageContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'end',
            height: 40,
        },
        errorMessage: {
            color: palette.error.main,
            fontSize: typography.fontSM,
        },
        mandatoryLegend: {
            marginBottom: 50,
        },
        labelContainer: {},
    });
}, { name: 'GqlCheckout_CustomRadioGroup' });
exports.default = customRadioGroupStyles;
